import { render, staticRenderFns } from "./FlowInfo.vue?vue&type=template&id=28e86fc5&"
import script from "./FlowInfo.vue?vue&type=script&lang=js&"
export * from "./FlowInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports